module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Leslie Jones\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Leslie Jones")]), _vm._v(" was an Army Intelligence officer for many years and she brings her first-hand experience to the pages of her work. She resides in Scottsdale, Arizona, and is currently hard at work on her next book.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19wrrlK/tc-custom/9780062363169.jpg?1720006962743",
      "alt": "This image is the cover for the book Bait, Duty & Honor"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bait, Duty & Honor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("In the next thrilling Duty & Honor novel, a female CIA agent and a Delta Force soldier must catch a deadly assassin… but do they know where the danger truly lies?")])]), _c('p', [_vm._v("After several assassination attempts on an allied royal, the CIA sends in operative Christina Madison—who bears a striking resemblance to the monarch—to pose as the famous princess and draw out her would-be killer.")]), _c('p', [_vm._v("When Delta Force Lieutenant Gabriel Morgan's team is assigned to Christina's undercover protection detail, he's less than thrilled. Gabe wants nothing to do with a woman whose rumored screw-up nearly got her last team killed. Not to mention there's bad blood between Gabe and the CIA—he doesn't trust anyone who lies for a living.")]), _c('p', [_vm._v("But once the trap is set and the assassin takes the bait, Gabe must protect her with his life … because danger lurks in the shadows, and now Christina is in the crosshairs.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0